/* eslint-disable no-use-before-define */
import { fromJS, Map } from 'immutable';
import getIn from 'lodash/get';

import * as Constants from '../../constants';
import { ApiActions } from '../../constants/ApiActions';
import { GraphQL } from '../../graphql';
import { createReducer } from '../../lib/ReducerUtils';

const INITIAL_STATE = Map({});

// STATION ENTITY REDUCER
export default createReducer(INITIAL_STATE, {
  [Constants.Playback.ActionTypes.SET_OR_CREATE_STATION_FINISHED]: updateStationLastPlayed,
  [ApiActions.GET_FRAGMENT_SUCCESS]: getFragmentSuccess,
  [ApiActions.UPDATE_STATION_SUCCESS]: updateStationSuccess,
  [GraphQL.Constants.OperationNameActions.GRAPHQL_UPDATE_STATION_DETAILS_SUCCESS]:
    updateStationSuccess,
  [ApiActions.GET_OR_SET_SHUFFLE_STATIONS_SUCCESS]: getOrSetShuffleStations,
  [ApiActions.CREATE_STATION_SUCCESS]: saveStationData,
  [ApiActions.FETCH_STATIONS_SUCCESS]: saveStationData,
  [ApiActions.GET_STATION_DETAILS_SUCCESS]: getStationDetailsSuccess,
  [ApiActions.GET_SEEDS_SUCCESS]: saveSeedData,
  [ApiActions.REMOVE_STATION_SUCCESS]: removeStation,
  [GraphQL.Constants.OperationNameActions.GRAPHQL_REMOVE_FROM_LIBRARY_SUCCESS]:
    removeStationGraphQL,
});

// CASE FUNCTIONS

function saveSeedData(state, action) {
  const stationId = action.params.content.stationId;
  return state.setIn([stationId, 'seeds'], fromJS(action.response.result.seeds));
}

function updateStationLastPlayed(state, action) {
  const stationId = action.data.stationId;
  return state.setIn([stationId, 'lastPlayed'], new Date().toISOString());
}

function getFragmentSuccess(state, action) {
  // getFragment returns updated checksums for HybridStations
  return state.withMutations(substate => {
    const stationId = action.updateEntitiesWith.stationId;
    if (action.response && action.response.result && action.response.result.checksum) {
      substate.setIn([stationId, 'hybridStation', 'checksum'], action.response.result.checksum);
    }
    if (action.response && action.response.result && state.getIn([stationId, 'isNew'])) {
      substate.setIn([stationId, 'isNew'], false);
    }
  });
}

function updateStationSuccess(state, action) {
  return state.mergeDeep(action.updateEntitiesWith);
}

function saveStationData(state, action) {
  return state.mergeDeep(action.response.entities.stations);
}

function saveStationDetailsData(state, action) {
  const { entities, result } = action.response;

  if (result && entities && entities.stations) {
    return state.merge({
      [result]: fromJS(entities.stations[result]),
    });
  }

  return state;
}

function getStationDetailsSuccess(state, action) {
  const update = saveStationDetailsData(state, action);
  const path = [action.response.result, 'lastPlayed'];
  const lastPlayed = state.getIn(path);
  const clientLastPlayed = lastPlayed && new Date(lastPlayed);
  // if currently station is playing, update the lastPlayed time with current time,
  // otherwise update client side lastPlayed time.
  if (action.params.content.isCurrentStation) {
    return update.setIn(path, new Date().toISOString());
  }
  if (clientLastPlayed) {
    return update.setIn(path, clientLastPlayed.toISOString());
  }
  return update;
}

function getOrSetShuffleStations(state, action) {
  const { entities, result } = action.response;
  if (entities && entities.stations && result) {
    const setPreviousShuffle = !!getIn(action, 'params.content.stationIds', false);
    return state.set(
      result,
      fromJS({
        ...entities.stations[result],
        previousShuffleStationIds: state.getIn(
          [result, setPreviousShuffle ? 'shuffleStationIds' : 'previousShuffleStationIds'],
          [],
        ),
      }),
    );
  }
  return state;
}

function removeStation(state, action) {
  const stationId = getIn(action, 'params.content.stationId');
  if (stationId) {
    return state.delete(stationId);
  }
  return state;
}

function removeStationGraphQL(state, action) {
  const variables = getIn(action, 'params.content.variables');
  const variablesJson = variables ? JSON.parse(variables) : {};
  const stationId = variablesJson.pandoraId;
  if (stationId) {
    return state.delete(stationId);
  }
  return state;
}
